import * as notif from "./notifications";
import {
  isNotFoundError,
  isNotAllowedError,
  isNotReadableError,
} from "./../tokbox/getUserMediaDevices";
import { getCurrentServerTime } from "./../../services/util";
import DeviceTypes from "../../model/DeviceTypes";
import getBrowserInfo from "./../../services/browserSupport";
import { logError } from "./../../services/logging";

import moment from "moment-timezone";

export const OTHER_USER_LATE_TIMEOUT = 2 * 60 * 1000; // 2 minutes.
const RECONNECTION_TIMEOUT = 2 * 60 * 1000; // 2 minutes.
export const SERVER_TIME_DIFFERENCE = 5 * 60 * 1000; // 5 minutes.

function sendNotification(notification) {
  if (notification) {
    try {
      notification.send();
    } catch (e) {
      logError("error while sending auto admin notification", {
        original_error: e,
        notification: notification,
      });
    }
  }
}

export function handleMediaError(error, details) {
  let notification = null;
  let err = null;
  let deviceType = null;
  if (error.audioError && error.videoError) {
    notification = new notif.BothDevicesProblemSessionNotification(details.lesson);
  } else if (error.audioError) {
    err = error.audioError;
    deviceType = DeviceTypes.AUDIO;
  } else if (error.videoError) {
    err = error.videoError;
    deviceType = DeviceTypes.VIDEO;
  }

  if (err) {
    if (isNotFoundError(err)) {
      notification = new notif.NotFoundDeviceSessionNotification(
        details.lesson,
        deviceType
      );
    } else if (isNotAllowedError(err)) {
      notification = new notif.NotAllowedDeviceSessionNotification(
        details.lesson,
        deviceType
      );
    } else if (isNotReadableError(err)) {
      notification = new notif.NotReadableDeviceSessionNotification(
        details.lesson,
        deviceType
      );
    }
  }

  sendNotification(notification);
}

export function handleReconnectionEvents(details) {
  const lesson = details.lesson;
  const now = new Date().getTime();
  if (!lesson.reconnection) {
    lesson.reconnection = {
      events: [],
      notificationSent: null,
    };
  }

  lesson.reconnection.events.push(now);
  if (lesson.reconnection.events.length >= 3) {
    const firstEventTime = lesson.reconnection.events[0];
    if (
      now - firstEventTime < RECONNECTION_TIMEOUT &&
      (!lesson.reconnection.notificationSent ||
        now - lesson.reconnection.notificationSent > RECONNECTION_TIMEOUT)
    ) {
      // Send notification if we had 3 events in 2 last minutes and we haven't sent a notification yet
      // or sent it more than 2 minutes ago.
      sendNotification(new notif.SeveralReconnectionsSessionNotification(details.lesson));
      lesson.reconnection.notificationSent = now;
    }
    lesson.reconnection.events = lesson.reconnection.events.slice(
      lesson.reconnection.events.length - 3
    );
  }
}

// TODO: [zoom] track
export function handleVideoDisabledEvent(details) {
  sendNotification(new notif.VideoDisabledSessionNotification(details.lesson));
}
// TODO: [zoom] track
export function handleVideoEnabledEvent(details) {
  sendNotification(new notif.VideoEnabledSessionNotification(details.lesson));
}

export function handleVideoDisableWarningEvent(details) {
  sendNotification(new notif.VideoDisableWarningSessionNotification(details.lesson));
}

export function handleVideoDisableWarningLiftedEvent(details) {
  sendNotification(
    new notif.VideoDisableWarningLiftedSessionNotification(details.lesson)
  );
}

export function handleUnsupportedBrowser(details) {
  const browser = getBrowserInfo();
  sendNotification(
    new notif.UnsupportedBrowserSessionNotification(
      details.lesson,
      browser.browser.name || "unknown",
      browser.os.name || "unknown"
    )
  );
}

export function handleOtherUserLateWarning(details) {
  sendNotification(
    new notif.OtherUserLateSessionNotification(
      details.lesson,
      details.otherLastSeen
        ? moment(details.otherLastSeen).format("[on] M/D [at] h:mmA [GMT]Z")
        : null
    )
  );
}

export function getOtherUserLateWarningTimeout(lesson) {
  if (
    moment(getCurrentServerTime()).isBefore(
      moment(lesson.scheduled).add(OTHER_USER_LATE_TIMEOUT, "milliseconds")
    )
  ) {
    // The current time is less than scheduled + OTHER_USER_LATE_TIMEOUT. We should wait before this point
    // in time before sending notifications.
    return (
      moment(lesson.scheduled)
        .add(OTHER_USER_LATE_TIMEOUT, "milliseconds")
        .toDate()
        .getTime() - getCurrentServerTime().getTime()
    );
  } else {
    // The current time is more than scheduled + OTHER_USER_LATE_TIMEOUT. We should send right away.
    // Give 1 sec, just to make sure that Waiting screen is replaced by Conversation.
    return 1000;
  }
}

export function handleDifferentUTCOffsets(user) {
  sendNotification(
    new notif.DifferentUTCOffsetsNotification(user, {
      id: moment.tz.guess(),
      utc_offset: moment().format("Z"),
    })
  );
}

export function handleServerTimeDifference(details) {
  sendNotification(new notif.TimeDifferenceNotification(details.user, details.offset));
}

export function handleBothConnected(details) {
  sendNotification(new notif.BothConnectedNotification(details.lesson));
}
